module.exports = __webpack_public_path__ + "static/media/than vang danh 1.f271d9d4.png";